import Vue from 'vue'
import Router from 'vue-router'
const Main = () => import('@/views/Main')
const Register = () => import('@/views/Register')
const RegisterResource = () => import('@/views/Register/register-next')
const Login = () => import('@/views/Login')
const FindPasswordOne = () => import('@/views/Login/find-password1')
const FindPasswordTwo = () => import('@/views/Login/find-password2')
const Certificate = () => import('@/views/Certificate/index')
const Home = () => import('@/views/Home')
const Service = () => import('@/views/Service')
// 协会简介
const Describe = () => import('@/views/AsssociationDescribe/describe')
// 协会动态
const Dynamic = () => import('@/views/AssociationDynamic')
const DynamicList = () => import('@/views/AssociationDynamic/list')
const DynamicDetail = () => import('@/views/AssociationDynamic/detail')
// 会员服务
const VipService = () => import('@/views/VipService')
const VipServiceJournalDetail = () =>
  import('@/views/VipService/journal-detail')
// 协会成员
const AssociationMember = () => import('@/views/AssociationMember/list')
// 专家委员会
const Proffesion = () => import('@/views/Proffesion')
// 联系我们
const Contract = () => import('@/views/Contract/list')
Vue.use(Router)
// 点击同一路由报错问题
const originalPush = Router.prototype.push
//修改原型对象中的push方法
Router.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject)
    return originalPush.call(this, location, onResolve, onReject)
  return originalPush.call(this, location).catch(err => err)
}
//export全局路由对象，把需要单应用页面都配置在这1
export default new Router({
  mode: 'history',
  scrollBehavior: () => ({
    y: 0
  }),
  routes: [
    {
      path: '/',
      name: 'index',
      component: Main,
      redirect: '/home',
      meta: {
        title: '首页'
      },
      children: [
        {
          path: 'certificate', // 电子证书
          name: 'certificate',
          meta: { title: '会员中心' },
          component: Certificate
        },
        {
          path: 'home',
          name: 'home',
          component: Home,
          meta: {
            title: '首页'
          }
        },
        {
          path: 'login',
          name: 'login',
          meta: { title: '登录' },
          component: Login
        },
        {
          path: 'findPassword',
          name: 'find-password-one',
          component: FindPasswordOne
        },
        {
          path: 'findPassword',
          name: 'find-password-two',
          component: FindPasswordTwo
        },
        {
          path: 'register',
          name: 'register',
          meta: { title: '注册' },
          component: Register
        },
        {
          path: 'resource',
          name: 'register-resource',
          meta: { title: '资料补充' },
          component: RegisterResource
        },
        {
          path: 'association', //服务
          name: 'association',
          redirect: 'association/',
          component: Service,
          meta: { title: '' },
          children: [
            {
              path: '/',
              name: 'describe',
              component: Service,
              meta: { title: '' },
              redirect: 'describe',
              children: [
                {
                  path: 'describe', //产业服务
                  name: 'describe',
                  component: Describe,
                  meta: { title: '协会简介' }
                },
                {
                  path: 'rule', //协会章程
                  name: 'rule',
                  component: Describe,
                  meta: { title: '协会章程' }
                },
                {
                  path: 'purpose', //协会宗旨
                  name: 'purpose',
                  component: Describe,
                  meta: { title: '协会宗旨' }
                },
                {
                  path: 'constuctor', //组织结构
                  name: 'constuctor',
                  component: Describe,
                  meta: { title: '组织结构' }
                },
                {
                  path: 'member', //协会成员
                  name: 'member',
                  component: Describe,
                  meta: { title: '协会成员' }
                }
              ]
            }
          ]
        },
        {
          path: 'dynamic',
          name: 'dynamic',
          component: Dynamic,
          redirect: 'dynamic/',
          children: [
            {
              path: '/',
              name: 'notify',
              component: Dynamic,
              redirect: 'list',
              meta: { title: '通知公告' },
              children: [
                {
                  path: 'list',
                  name: 'list',
                  component: DynamicList
                },
                {
                  path: 'detail',
                  name: 'dynamic-detail',
                  meta: { title: '动态详情' },
                  component: DynamicDetail
                }
              ]
            },
            {
              path: 'news',
              name: 'news',
              component: Dynamic,
              meta: { title: '协会要闻' },
              redirect: 'news',
              children: [
                {
                  path: '/',
                  name: 'news',
                  component: DynamicList
                },
                {
                  path: 'detail',
                  name: 'dynamic-detail',
                  meta: { title: '动态详情' },
                  component: DynamicDetail
                }
              ]
            },
            {
              path: 'industry-query',
              name: 'industry-query',
              component: Dynamic,
              meta: { title: '行业资讯' },
              redirect: 'industry-query',
              children: [
                {
                  path: '/',
                  name: 'industry-query',
                  component: DynamicList
                },
                {
                  path: 'detail',
                  name: 'dynamic-detail',
                  meta: { title: '动态详情' },
                  component: DynamicDetail
                }
              ]
            }
          ]
        },
        {
          path: 'vip-service',
          name: 'vip-service',
          redirect: 'vip-service/',
          component: Service,
          meta: { title: '' },
          children: [
            {
              path: '/',
              name: 'meet-slogan',
              component: Service,
              meta: { title: '' },
              redirect: 'meet-slogan',
              children: [
                {
                  path: 'meet-slogan', //产业服务
                  name: 'meet-slogan',
                  component: VipService,
                  meta: { title: '活动沙龙' }
                },
                {
                  path: 'product-source', //协会章程
                  name: 'product-source',
                  component: VipService,
                  meta: { title: '产业资源' }
                },
                // {
                //   path: "profession", //专家智库
                //   name: "profession",
                //   component: VipService,
                //   meta: { title: "专家智库" }
                // },
                {
                  path: 'clutivate', //专业培训
                  name: 'clutivate',
                  component: VipService,
                  meta: { title: '专业培训' }
                },
                {
                  path: 'journal', //协会刊物
                  name: 'journal',
                  redirect: 'journal/',
                  component: Service,
                  meta: { title: '协会刊物' },
                  children: [
                    { path: '/', name: 'journal', component: VipService },
                    {
                      path: 'detail',
                      name: 'journal-detail',
                      component: VipServiceJournalDetail,
                      meta: { title: '详情', currentAuth: true }
                    }
                  ]
                },
                {
                  path: 'download', //组织结构
                  name: 'download',
                  component: VipService,
                  meta: { title: '资料下载' }
                },
                {
                  path: 'join-member', //协会成员
                  name: 'join-member',
                  component: VipService,
                  meta: { title: '加入会员' }
                }
              ]
            }
          ]
        },
        {
          path: 'association-member',
          name: 'association-member',
          redirect: 'association-member/',
          component: Service,
          meta: { title: '' },
          children: [
            {
              path: '/',
              name: 'president-unit',
              component: Service,
              meta: { title: '' },
              redirect: 'president-unit',
              children: [
                {
                  path: 'president-unit',
                  name: 'president-unit',
                  component: AssociationMember,
                  meta: { title: '会长单位' }
                },
                {
                  path: 'deputy-president-unit',
                  name: 'deputy-president-unit',
                  component: AssociationMember,
                  meta: { title: '副会长单位' }
                },
                {
                  path: 'secretary-unit',
                  name: 'secretary-unit',
                  component: AssociationMember,
                  meta: { title: '秘书长单位' }
                },
                {
                  path: 'supervisor-unit',
                  name: 'supervisor-unit',
                  component: AssociationMember,
                  meta: { title: '监事单位' }
                },
                {
                  path: 'director-unit',
                  name: 'director-unit',
                  component: AssociationMember,
                  meta: { title: '理事单位' }
                },
                {
                  path: 'vip-unit',
                  name: 'vip-unit',
                  component: AssociationMember,
                  meta: { title: '会员单位' }
                }
              ]
            }
          ]
        },
        {
          path: 'profession', //专家智库
          name: 'profession',
          component: Proffesion,
          meta: { title: '专家委员会' }
        },
        {
          path: 'contract',
          name: 'contract',
          component: Contract,
          meta: { title: '联系我们' }
        }
      ]
    },
    //404页面
    {
      path: '*',
      component: () => import('@/views/404')
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js